import Store from 'lockr'
import {
  defaultWebsocketPort,
  defaultWebsocketPortSecure,
  manateeHost,
  websocketPort,
  websocketPortSecure
} from './conf'

// This file provides functionality for polling for port info injected by the steller extension
// It also handles detecting the presence of the extension

let activeInterval = 0
export function runPortPoller(store) {
  // Checks if conf has changed for this specific value relative to the current store socket conf
  function checkValue(valueFn, valueName) {
    const currentConf = _.cloneDeep(store.state.debugger.debugSocketConf)
    const potentialNewValue = valueFn()
    if (potentialNewValue && currentConf[valueName] !== potentialNewValue) {
      console.log(`Socket poller got new value for debug socket ${valueName}: ${potentialNewValue}`)
      currentConf[valueName] = potentialNewValue
      store.commit('debugger/setDebugSocketConf', currentConf) // Update vuex store
      Store.set('debugSocketConf', currentConf) // Update localstorage
    }
  }

  // Give 2 second grace period before warning about missing extension
  let stellerDetectedUnlocked = false
  setTimeout(() => (stellerDetectedUnlocked = true), 2000)

  // Keep track of whether we have seen signs of steller/puppeteer since page load
  let stellerAttributeSeen = false
  function checkSteller() {
    const stellerVersion = document.body.getAttribute('puppeteer_loaded')
    const portAttrPresent = !!document.body.getAttribute('manatee_monitorport')
    if (!stellerAttributeSeen && stellerDetectedUnlocked) {
      const stellerDetected = !!stellerVersion || portAttrPresent
      store.commit('debugger/setStellerDetected', stellerDetected)
      store.commit('config/setStellerVersion', stellerVersion)
      stellerAttributeSeen = stellerDetected // Once we see the extension, stop checking
    }
  }

  // Initialize vuex store from local storage/defaults
  const localStorageConf = Store.get('debugSocketConf') || {}
  checkValue(() => localStorageConf.port || defaultWebsocketPort(), 'port')
  checkValue(() => localStorageConf.securePort || defaultWebsocketPortSecure(), 'securePort')
  checkValue(() => localStorageConf.host, 'host')

  // Start interval to monitor body attributes set by steller
  if (activeInterval) clearInterval(activeInterval)
  activeInterval = setInterval(() => {
    checkValue(websocketPort, 'port')
    checkValue(websocketPortSecure, 'securePort')
    checkValue(manateeHost, 'host')
    checkSteller()
  }, 1000)

  // Return a 'stop polling' function
  return () => {
    clearInterval(activeInterval)
    activeInterval = 0
  }
}
